import { makeStyles } from '@vakantiesnl/components/src/styles/themes/themewrapper';

export const useCustomStyles = makeStyles()((theme) => ({
	priceOverview: {
		display: 'flex',
		flexDirection: 'column',
		flex: '1 1 auto',
	},
	availabilityContainer: {
		display: 'flex',
		flexDirection: 'column',
		marginTop: theme.spacing.medium,
	},
	subText: {
		color: theme.body.foreground.color.dimmed,
		textAlign: 'center',
		margin: `${theme.spacing.small} 0`,
	},
	footerItem: {
		display: 'flex',
		justifyContent: 'center',
		flexDirection: 'column',
		alignItems: 'center',
		gap: theme.spacing.xxsmall,
	},
	partnerList: {
		display: 'inline-flex',
		listStyle: 'none',
		gap: theme.spacing.xxsmall,
	},
	footerItemList: {
		display: 'flex',
		flexDirection: 'column',
		gap: theme.spacing.small,
	},
	tourOperatorLogo: {
		objectFit: 'contain',
	},
	logoContainer: {
		position: 'relative',
		height: theme.spacing.xlarge,
		width: '100%',
	},
	footerItemTitle: {
		color: theme.palette.neutral[100],
	},
}));
